import React from 'react';

const TrialPaywall = ({ onAssinarPro, checkoutLoading, checkoutError, onDismissError, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      <div className="relative bg-white rounded-2xl shadow-2xl p-8 sm:p-10 max-w-sm w-full text-center">
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-150"
            aria-label="Fechar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
        <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-5 text-2xl">
          🔒
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-3">
          Limite do Teste Gratuito Atingido
        </h2>
        <p className="text-sm text-gray-500 mb-7 leading-relaxed">
          Durante o Teste Gratuito você pode usar cada ferramenta apenas duas vezes. Para continuar usando todas as ferramentas sem limites, assine o Plano PRO ou feche esta caixa e use outra(s) ferramenta(s) que ainda não tenha usado duas vezes.
        </p>
        <button
          onClick={onAssinarPro}
          disabled={checkoutLoading}
          className="w-full inline-flex items-center justify-center gap-2 text-white text-sm font-semibold py-3 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
          style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)' }}
        >
          {checkoutLoading ? (
            <>
              <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              <span>Processando...</span>
            </>
          ) : (
            <span>ASSINAR PRO</span>
          )}
        </button>
        {checkoutError && (
          <div className="mt-4 flex items-center gap-2 bg-red-50 border border-red-200 text-red-600 text-xs px-4 py-2.5 rounded-xl">
            <span className="flex-1">{checkoutError}</span>
            {onDismissError && (
              <button onClick={onDismissError} className="text-red-400 hover:text-red-600 flex-shrink-0">✕</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TrialPaywall;
